export enum SUPPORTED_CHAINIDS_TYPE {
  MAINNET = 1,
  OPTIMISM = 10,
  POLYGON = 137,
}

export const SUPPORTED_CHAINIDS = [1, 10, 137] as const;

type NetworkInfo = {
  name: string;
  color: string;
};

export const NETWORKS: Record<SUPPORTED_CHAINIDS_TYPE, NetworkInfo> = {
  [SUPPORTED_CHAINIDS_TYPE.MAINNET]: {
    name: "Ethereum",
    color: "",
  },
  [SUPPORTED_CHAINIDS_TYPE.OPTIMISM]: {
    name: "Optimism",
    color: "",
  },
  [SUPPORTED_CHAINIDS_TYPE.POLYGON]: {
    name: "Polygon",
    color: "",
  },
} as const;

type BlockExplorer = {
  name: string;
  url: string;
};

export const BLOCK_EXPLORERS: Record<SUPPORTED_CHAINIDS_TYPE, BlockExplorer> = {
  [SUPPORTED_CHAINIDS_TYPE.MAINNET]: {
    name: "Etherscan",
    url: "https://etherscan.io",
  },
  [SUPPORTED_CHAINIDS_TYPE.OPTIMISM]: {
    name: "Etherscan",
    url: "https://optimistic.etherscan.io",
  },
  [SUPPORTED_CHAINIDS_TYPE.POLYGON]: {
    name: "PolygonScan",
    url: "https://polygonscan.com",
  },
} as const;
